<div class="dashboard-list-container">
  <div class="dashboard-list-group" *ngFor="let group of data?.groups">
    <label class="text-truncate">{{group.label}}</label>
    <div class="d-flex flex-wrap">
      <small *ngFor="let item of group.items">{{item.label}}</small>
    </div>
  </div>
</div>
